import { render, staticRenderFns } from "./VendorProductPage.vue?vue&type=template&id=0d9a4310&"
import script from "./VendorProductPage.vue?vue&type=script&lang=js&"
export * from "./VendorProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports